import {   useEffect, useState } from 'react'
import type {FC, PropsWithChildren} from 'react';
import { SyncIndicator } from '@/components/app'
import { AppContext } from '@/context'
import { SubscriptionProvider } from '@/context/SubscriptionContext'
import { LocaleProvider } from '@/lib/i18n/LocaleProvider'
import { useLeaderElection } from '@/hooks/useLeaderElection'

export const AppProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [isLeader, setIsLeader] = useState<boolean>(false)
  useLeaderElection(setIsLeader)
  const [isDbLoading, setIsDbLoading] = useState<boolean>(true)
  const [isAppLoading, setIsAppLoading] = useState<boolean>(true)
  const [hasAppError, setHasAppError] = useState<boolean>(false)

  // Token refresh is handled by AuthProvider (lib/auth/tokenRefresh.ts)

  useEffect(() => {
    if (!isDbLoading) {
      setIsAppLoading(false)
    }
  }, [isDbLoading])

  return (
    <>
      <AppContext.Provider
        value={{
          isLeader,
          setIsLeader,
          isAppLoading,
          isDbLoading,
          setIsDbLoading,
          hasAppError,
          setHasAppError,
        }}
      >
        <LocaleProvider>
          <SubscriptionProvider>
            <SyncIndicator />
            {children}
          </SubscriptionProvider>
        </LocaleProvider>
      </AppContext.Provider>
    </>
  )
}
